<div class="diagram">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 543 527">
    <g id="SUV" transform="translate(-427 -126)">
      <g id="Elements" transform="translate(336.986 -55.101)">
        <circle
          id="Ellipse_237"
          data-name="Ellipse 237"
          cx="0.882"
          cy="0.882"
          r="0.882"
          transform="translate(369.853 259.216)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_934"
          data-name="Path 934"
          d="M523.794,270.559s-28.748,6.682-30.893,9.3"
          transform="translate(-159.802 -10.461)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_935"
          data-name="Path 935"
          d="M695.891,270.559s24.594,5.074,29.18,7.874"
          transform="translate(-318.413 -10.461)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g id="Group_1164" data-name="Group 1164" transform="translate(414.262 272.895)">
          <path
            id="Path_940"
            data-name="Path 940"
            d="M899.947,370.728,880.49,345.077s13.9,4.686,18.345,16.121"
            transform="translate(-876.916 -341.583)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_941"
            data-name="Path 941"
            d="M903.465,363.785s7.445,2.283,8.994,8.736"
            transform="translate(-894.868 -356.201)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_1165" data-name="Group 1165" transform="translate(301.881 272.895)">
          <path
            id="Path_943"
            data-name="Path 943"
            d="M359.081,370.728l19.457-25.651s-13.9,4.686-18.345,16.121"
            transform="translate(-357.119 -341.583)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_944"
            data-name="Path 944"
            d="M392.958,363.785s-7.445,2.283-8.994,8.736"
            transform="translate(-376.562 -356.201)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <path
          id="Path_946"
          data-name="Path 946"
          d="M451.564,592.783l-.437,9.014a2.059,2.059,0,0,0,2.383,1.985c2.224-.318,23.666-6.671,23.666-6.671A3.19,3.19,0,0,0,479,594.649c.159-1.747.318-11.912.318-11.912s-1.032-2.462-2.382-2.065-23.587,8.259-23.587,8.259S451.716,589.648,451.564,592.783Z"
          transform="translate(-127.161 -252.742)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_947"
          data-name="Path 947"
          d="M460.478,600.887l-.318,8.18s-.238.794,1.271.715,21.2-5.8,21.2-5.8,1.35,0,1.429-1.827.318-7.7.318-7.7-.635-2.3-1.747-2.065S461.113,598.742,460.478,600.887Z"
          transform="translate(-134.208 -261.918)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_948"
          data-name="Path 948"
          d="M779.292,592.783l.437,9.014a2.06,2.06,0,0,1-2.383,1.985c-2.224-.318-23.666-6.671-23.666-6.671a3.19,3.19,0,0,1-1.827-2.462c-.159-1.747-.318-11.912-.318-11.912s1.032-2.462,2.382-2.065,23.586,8.259,23.586,8.259S779.14,589.648,779.292,592.783Z"
          transform="translate(-361.893 -252.742)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_949"
          data-name="Path 949"
          d="M784.521,600.887l.318,8.18s.238.794-1.271.715-21.2-5.8-21.2-5.8-1.35,0-1.429-1.827-.318-7.7-.318-7.7.635-2.3,1.747-2.065S783.886,598.742,784.521,600.887Z"
          transform="translate(-368.988 -261.918)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_64"
          data-name="Line 64"
          y2="11.559"
          transform="translate(343.863 331.821)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_65"
          data-name="Line 65"
          y2="11.559"
          transform="translate(337.547 333.699)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_66"
          data-name="Line 66"
          y2="11.559"
          transform="translate(331.908 335.605)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_67"
          data-name="Line 67"
          y2="10.834"
          transform="translate(409.659 335.83)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_68"
          data-name="Line 68"
          y2="10.834"
          transform="translate(403.746 333.744)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_69"
          data-name="Line 69"
          y2="10.834"
          transform="translate(397.505 332.546)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_950"
          data-name="Path 950"
          d="M403.58,378.131s1.183-20.966,16.431-44.314"
          transform="translate(-90.009 -59.889)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_951"
          data-name="Path 951"
          d="M870.021,378.131s-1.183-20.966-16.431-44.314"
          transform="translate(-441.635 -59.889)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_952"
          data-name="Path 952"
          d="M385.992,580.629s-3.812,27.759-2.5,37.408"
          transform="translate(-74.097 -252.742)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_953"
          data-name="Path 953"
          d="M935.255,580.629s3.812,27.759,2.5,37.408"
          transform="translate(-505.446 -252.742)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_954"
          data-name="Path 954"
          d="M399.378,689.053a40.655,40.655,0,0,0,.887,13.1l9.173,41.455s40.621-13.461,97.443,0c0,0,11.793-45.863,10.185-52.891,0,0-25.376-20.915-62.123-19.094C454.942,671.627,428.987,669.993,399.378,689.053Z"
          transform="translate(-86.582 -323.758)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_957"
          data-name="Path 957"
          d="M594.47,681.98s-2.144,1.955-.6,3.146,11.2,2.382,12.627,1.787V681.98s.357-1.619-3.574-1.261C602.928,680.719,596.615,680.382,594.47,681.98Z"
          transform="translate(-238.261 -330.91)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_958"
          data-name="Path 958"
          d="M655.426,698.516v-2.66l-1.787-.542v3.044Z"
          transform="translate(-285.399 -342.354)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_960"
          data-name="Path 960"
          d="M406.811,701.611l18.722-5.956.635-4.646,19.715-4.338a14.253,14.253,0,0,0,.357,3.491"
          transform="translate(-92.533 -335.601)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_961"
          data-name="Path 961"
          d="M717.935,680.667s1.394,3.83,1.191,4.8l.02-4.156s21.53,2.381,34.327,10.364v2.144"
          transform="translate(-335.638 -330.909)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_962"
          data-name="Path 962"
          d="M834.558,730.658s-12.6-4.253-24.539-6.812"
          transform="translate(-407.59 -364.648)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_964"
          data-name="Path 964"
          d="M420.977,762.49s34.605-6.075,36.333-6.075,3.973-.715,7.943-8.219"
          transform="translate(-103.602 -383.674)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_965"
          data-name="Path 965"
          d="M753.035,762.49s-34.605-6.075-36.333-6.075-3.973-.715-7.943-8.219"
          transform="translate(-328.469 -383.674)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_968"
          data-name="Path 968"
          d="M909.731,309.025s20.37,3.8,21.145,43.182"
          transform="translate(-485.503 -40.517)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_969"
          data-name="Path 969"
          d="M343.614,310.024s-20.262,3.583-21.036,42.964"
          transform="translate(-26.716 -41.298)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g id="Group_1168" data-name="Group 1168" transform="translate(421.904 372.681)">
          <path
            id="Path_972"
            data-name="Path 972"
            d="M921.078,785.519s-7.028.655-7.624,3.574-12.032,40.442-12.032,53.486L899.1,880.818s-.417,1.588,11.972-4.209c0,0,6.711-1.628,7.227-2.025l2.78-2.7Z"
            transform="translate(-899.098 -785.519)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_973"
            data-name="Path 973"
            d="M911.924,944.984l-11.43,7.252,2.088-35.152s5.068-26.083,5.512-27.8l6.451-5.966Z"
            transform="translate(-900.189 -861.934)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_974"
            data-name="Path 974"
            d="M987.214,1082.832l1.31,1.191-.357,6.671-1.608,1.251s.238,4.824.715,5,1.31-.417,1.727-3.991v-9.53s.6-4.348-.774-4.765C988.227,1078.662,986.38,1080.985,987.214,1082.832Z"
            transform="translate(-967.438 -1014.574)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <path
          id="Path_976"
          data-name="Path 976"
          d="M911.924,944.984l-11.43,7.252,2.088-35.152s5.068-26.083,5.512-27.8l6.451-5.966Z"
          transform="translate(-478.285 -489.253)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_977"
          data-name="Path 977"
          d="M987.214,1082.832l1.31,1.191-.357,6.671-1.608,1.251s.238,4.824.715,5,1.31-.417,1.727-3.991v-9.53s.6-4.348-.774-4.765C988.227,1078.662,986.38,1080.985,987.214,1082.832Z"
          transform="translate(-545.534 -641.893)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g id="Group_1169" data-name="Group 1169" transform="translate(297.319 372.681)">
          <path
            id="Path_979"
            data-name="Path 979"
            d="M366.733,944.984l11.43,7.252-2.087-35.152s-5.068-26.083-5.512-27.8l-6.451-5.966Z"
            transform="translate(-356.488 -861.934)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_980"
            data-name="Path 980"
            d="M332.473,1082.832l-1.31,1.191.357,6.671,1.608,1.251s-.238,4.824-.715,5-1.31-.417-1.727-3.991v-9.53s-.6-4.348.774-4.765C331.461,1078.662,333.307,1080.985,332.473,1082.832Z"
            transform="translate(-330.27 -1014.574)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_1171" data-name="Group 1171" transform="translate(421.25 459.045)">
          <path
            id="Path_985"
            data-name="Path 985"
            d="M981.334,1467.241l1.311,1.191-.358,6.671-1.608,1.251s.238,4.824.715,5,1.311-.417,1.727-3.991v-9.53s.6-4.348-.774-4.765C982.347,1463.072,980.5,1465.395,981.334,1467.241Z"
            transform="translate(-962.19 -1401.307)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_987"
            data-name="Path 987"
            d="M898.74,1238.99l11.695-2.859-.626,41.813-11.068,2.62Z"
            transform="translate(-898.165 -1223.98)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_988"
            data-name="Path 988"
            d="M910.713,1434.466l-.794,26.048-9.451-23.507Z"
            transform="translate(-899.515 -1378.955)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_1172" data-name="Group 1172" transform="translate(296.555 459.045)">
          <path
            id="Path_989"
            data-name="Path 989"
            d="M338.856,1467.241l-1.31,1.191.357,6.671,1.608,1.251s-.238,4.824-.715,5-1.31-.417-1.727-3.991v-9.53s-.6-4.348.774-4.765C337.844,1463.072,339.69,1465.395,338.856,1467.241Z"
            transform="translate(-334.494 -1401.307)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_991"
            data-name="Path 991"
            d="M388.842,1238.99l-11.695-2.859.626,41.813,11.068,2.62Z"
            transform="translate(-365.91 -1223.98)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_992"
            data-name="Path 992"
            d="M382.051,1434.466l.794,26.048,9.45-23.507Z"
            transform="translate(-369.742 -1378.955)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_1173" data-name="Group 1173" transform="translate(424.745 534.053)">
          <line
            id="Line_70"
            data-name="Line 70"
            x1="0.017"
            y2="47.884"
            transform="translate(18.851 3.081)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_1174" data-name="Group 1174" transform="translate(294.826 534.095)">
          <line
            id="Line_71"
            data-name="Line 71"
            x2="0.017"
            y2="47.884"
            transform="translate(2.739 3.081)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_1175" data-name="Group 1175" transform="translate(419.404 520.81)">
          <path
            id="Path_996"
            data-name="Path 996"
            d="M889.51,1463.072l.575,13.878s19.338,58.37,2.919,72.665l-5.341-24.837,2.353-47.664"
            transform="translate(-887.664 -1463.072)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_997"
            data-name="Path 997"
            d="M900.468,1607.3l5.48,19.933s.476,1.35,1.191.715,0-16.28,0-16.28l-5.48-26.128s-.715-.238-.635,1.668S900.468,1607.3,900.468,1607.3Z"
            transform="translate(-897.669 -1558.761)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_1176" data-name="Group 1176" transform="translate(310.14 517.804)">
          <path
            id="Path_998"
            data-name="Path 998"
            d="M397.989,1449.321l-.575,13.878s-19.338,58.37-2.919,72.665l5.341-24.837-2.353-47.664"
            transform="translate(-387.884 -1449.321)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_999"
            data-name="Path 999"
            d="M404.768,1593.554l-5.48,19.933s-.476,1.35-1.191.715,0-16.28,0-16.28l5.48-26.128s.715-.238.635,1.668S404.768,1593.554,404.768,1593.554Z"
            transform="translate(-395.616 -1545.011)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <path
          id="Path_1000"
          data-name="Path 1000"
          d="M377.147,1585.535l2.347,34.456s-.208,17.753,6.611,22.308c0,0-5.242,13.529,54,13.529,0,0,38.075.913,54-10.522,8-5.746,6.611-27.4,6.611-27.4l2.165-32.371"
          transform="translate(-69.354 -1037.951)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_202"
          data-name="Rectangle 202"
          width="67.781"
          height="38.78"
          rx="12"
          transform="translate(336.792 431.462)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_203"
          data-name="Rectangle 203"
          width="63.969"
          height="34.652"
          rx="12"
          transform="translate(338.698 433.527)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1002"
          data-name="Path 1002"
          d="M655.854,1649.366h-.61a2.293,2.293,0,0,0-2.286,2.286v4.494a2.293,2.293,0,0,0,2.286,2.286h.29a.761.761,0,0,1-.759-.759v-2.68a.759.759,0,1,1,1.519,0v2.68a.761.761,0,0,1-.759.759h.32a2.293,2.293,0,0,0,2.286-2.286v-4.494A2.293,2.293,0,0,0,655.854,1649.366Z"
          transform="translate(-284.866 -1087.827)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1003"
          data-name="Path 1003"
          d="M442.549,1723.048s-.547,18.941,48.591,18.941c0,0,47.607,3.336,48.721-19.239,0,0-2.383-5.453-5.778-6,0,0-1.906-.7-3.1,0s-10.6,3.317-40.86,3.317c0,0-38.833-1.577-42.05-3.317C448.077,1716.747,444.484,1717.355,442.549,1723.048Z"
          transform="translate(-120.458 -1140.234)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_72"
          data-name="Line 72"
          x1="0.476"
          y1="12.551"
          transform="translate(327.62 576.514)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_73"
          data-name="Line 73"
          y1="12.551"
          x2="0.476"
          transform="translate(413.02 576.514)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1006"
          data-name="Path 1006"
          d="M476.555,1845.848a12.122,12.122,0,0,0,6.75,3.137c4.527.715,20.489,3.177,24.857,2.541l.715-.635h17.63l.873.739s25.889-.263,31.051-5.782"
          transform="translate(-147.029 -1241.354)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1007"
          data-name="Path 1007"
          d="M844.619,1813.7s2.918,8.05,1.846,12.81"
          transform="translate(-434.626 -1216.234)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1008"
          data-name="Path 1008"
          d="M478.03,1813.7a24.267,24.267,0,0,0-1.985,12.81"
          transform="translate(-146.519 -1216.234)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1011"
          data-name="Path 1011"
          d="M641.652,1836.585"
          transform="translate(-276.032 -1234.115)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1014"
          data-name="Path 1014"
          d="M356.477,1819.876s-4.667-3.746-5-5.488l-6.234-12.5,1.866,7.983s1.549,6.592,4.606,8.219A14.383,14.383,0,0,0,356.477,1819.876Z"
          transform="translate(-44.423 -1207.003)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1015"
          data-name="Path 1015"
          d="M922.026,1828.933s5.062-3.191,5.594-4.884l7.613-11.713-2.76,7.719s-2.287,6.373-5.51,7.643A14.377,14.377,0,0,1,922.026,1828.933Z"
          transform="translate(-495.11 -1215.168)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1016"
          data-name="Path 1016"
          d="M508.158,1919.769v4.209h1.43l.556-4.209"
          transform="translate(-171.723 -1299.114)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1017"
          data-name="Path 1017"
          d="M531.406,1924.491v3.812h1.509l.238-3.812"
          transform="translate(-189.888 -1302.803)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1018"
          data-name="Path 1018"
          d="M553.927,1924.491v3.812h1.906v-3.215"
          transform="translate(-207.486 -1302.803)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1019"
          data-name="Path 1019"
          d="M577.175,1927.22l.4,3.85h1.35v-3.85"
          transform="translate(-225.652 -1304.936)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1020"
          data-name="Path 1020"
          d="M601.059,1929.4l.417,4.01h1.31v-4.01"
          transform="translate(-244.314 -1306.635)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1021"
          data-name="Path 1021"
          d="M624.216,1929.4l.3,4.01h1.37l.3-4.01"
          transform="translate(-262.408 -1306.635)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1022"
          data-name="Path 1022"
          d="M648.463,1929.4l.417,4.427h1.489V1929.4"
          transform="translate(-281.354 -1306.635)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1023"
          data-name="Path 1023"
          d="M671.076,1929.4l.655,4.01h1.31v-4.01"
          transform="translate(-299.023 -1306.635)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1024"
          data-name="Path 1024"
          d="M696.685,1929.4l.6,4.01h1.251v-4.01"
          transform="translate(-319.033 -1306.635)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1025"
          data-name="Path 1025"
          d="M720.932,1929.4l.357,4.01h.953l.357-4.01"
          transform="translate(-337.98 -1306.635)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1026"
          data-name="Path 1026"
          d="M743.817,1929.4l.715,3.713h1.132V1929.4"
          transform="translate(-355.861 -1306.635)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1027"
          data-name="Path 1027"
          d="M768.064,1925.672c.059.238.417,4.189.417,4.189l1.489-.258v-3.931"
          transform="translate(-374.808 -1303.726)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1028"
          data-name="Path 1028"
          d="M791.085,1922.292l.715,4.05h1.31l.149-4.348"
          transform="translate(-392.795 -1300.852)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_1029"
          data-name="Path 1029"
          d="M814.2,1920.681l.357,3.832,1.35-.209v-3.99"
          transform="translate(-410.854 -1299.539)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
      </g>
      <text
        id="SUV-2"
        data-name="SUV"
        transform="translate(682 139)"
        font-size="14"
        font-weight="700"
      >
        <tspan x="0" y="0">Hatchback</tspan>
      </text>

      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_stop_lamps'] || ''"
        [attr.data-name]="'exterior.suv.rr_stop_lamp' | translate"
      >
        <rect
          id="Rectangle_38"
          data-name="Rectangle 38"
          width="149"
          height="18"
          rx="9"
          transform="translate(427 592)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 592)"
        />
        <g class="arrow" id="Arrow">
          <path
            id="Path_509"
            data-name="Path 509"
            d="M6285.43,979.656l-103.1,50H6157"
            transform="translate(-5581.036 -428.655)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_215"
            data-name="Ellipse 215"
            cx="3"
            cy="3"
            r="3"
            transform="translate(700 548)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RR_Stop_Lamp-2"
          data-name="Rear Stop Lamp"
          d="M642.406,1836.9s-.238,2.462,1.271,2.621,6.671,0,6.671,0a9.4,9.4,0,0,0,.794-2.621h.754v1.8s-.238,1.935-1.549,1.935h-7.207s-1.489-.714-1.489-1.7v-2.352Z"
          transform="translate(60.954 -1289.216)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RR_Stop_Lamp-3"
          data-name="Rear Stop Lamp"
          transform="translate(470 604)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.rr_stop_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0"
          data-name="3.0"
          transform="translate(559 603)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_hatch_door'] || ''"
        [attr.data-name]="'exterior.suv.rr_hatch_door' | translate"
      >
        <rect
          id="Rectangle_38-2"
          data-name="Rectangle 38"
          width="116"
          height="18"
          rx="9"
          transform="translate(460 560)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-2"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 560)"
        />
        <g class="arrow" id="Arrow-2" data-name="Arrow">
          <path
            id="Path_507"
            data-name="Path 507"
            d="M6239.308,991.459l-62.46,11.028H6157"
            transform="translate(-5582.999 -435.364)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_216"
            data-name="Ellipse 216"
            cx="3"
            cy="3"
            r="3"
            transform="translate(653 553)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RR_Hatch_Door-2"
          data-name="RR Hatch Door"
          d="M426.358,1752.129l-.194,1.018-4.336,22.8v6.208s20.671,8.932,53.187,8.218c0,0,36.685-.234,53-8.218,0,0,1.138-12.746-4.348-30.021,0,0-.3,19.894-48.721,17.749,0,0-20.562,1.733-38.716-6.871A19.369,19.369,0,0,1,426.358,1752.129Z"
          transform="translate(232.719 -1223.225)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RR_Hatch_Door-3"
          data-name="RR Hatch Door"
          transform="translate(485 573)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.rr_hatch_door' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-2"
          data-name="3.0"
          transform="translate(559 572)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_bumper'] || ''"
        [attr.data-name]="'exterior.suv.rr_bumpher' | translate"
      >
        <rect
          id="Rectangle_38-3"
          data-name="Rectangle 38"
          width="101"
          height="18"
          rx="9"
          transform="translate(474 529)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-3"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 529)"
        />
        <g class="arrow" id="Arrow-3" data-name="Arrow">
          <path
            id="Path_506"
            data-name="Path 506"
            d="M6216.753,992.584l-45.04-12.929H6157"
            transform="translate(-5581.036 -443.01)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_217"
            data-name="Ellipse 217"
            cx="3"
            cy="3"
            r="3"
            transform="translate(633 547)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RR_Bumpher-2"
          data-name="RR Bumpher"
          d="M339.361,1755.407s-1.229,26.8,16.251,31.449,41.067,6.79,56.255,6.79,31.389.915,55.273-7.583c0,0,9.184.13,13.245-19.84l3.963-19.655s-3.014,26.887-13,30.818l-13.917,3.534s.377,7.406-9.788,8.279c0,0-20.216,2.78-35.8,2.78,0,0-33.452,0-38.1-2.74,0,0-10.761-.879-10.2-7.567,0,0-15.883-4.068-16.995-6.291S342.736,1774.189,339.361,1755.407Z"
          transform="translate(297.171 -1218.878)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RR_Bumpher-3"
          data-name="RR Bumpher"
          transform="translate(495 541)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.suv.rr_bumpher' | translate }}</tspan>
        </text>
        <text
          id="_3.0-3"
          data-name="3.0"
          transform="translate(559 541)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['hood'] || ''"
        [attr.data-name]="'exterior.suv.hood' | translate"
      >
        <rect
          id="Rectangle_38-4"
          data-name="Rectangle 38"
          width="64"
          height="18"
          rx="9"
          transform="translate(512 247)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-4"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 247)"
        />
        <g class="arrow" id="Arrow-4" data-name="Arrow">
          <path
            id="Path_498"
            data-name="Path 498"
            d="M6282.037,989.11l-100.374-9.454H6157"
            transform="translate(-5581.036 -724.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_226"
            data-name="Ellipse 226"
            cx="3"
            cy="3"
            r="3"
            transform="translate(698 262)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Hood-2"
          data-name="Hood"
          d="M363.986,322.585l-1.31,60.515s4.408,5.718,5.956,5.718c0,0,22.96-19.239,59.9-19.239s59.994,19.239,59.994,19.239,1.549.476,6.433-5.956l-1.638-60.276L472.309,294.75l-3.971-2.78s-.238.953-2.621.477-34.864-7.306-34.864-7.306H427.2l-36.611,7.306s-1.32-.174-1.261-.675l-4.408,2.978Z"
          transform="translate(278.938 -76.956)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Hood-3"
          data-name="Hood"
          transform="translate(526 259)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.suv.hood' | translate }}</tspan>
        </text>
        <text
          id="_3.0-4"
          data-name="3.0"
          transform="translate(559 259)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_head_lamp'] || ''"
        [attr.data-name]="'exterior.suv.lft_head_lamp' | translate"
      >
        <g id="Group_106" data-name="Group 106" transform="translate(469.378 217)">
          <rect
            id="Rectangle_38-5"
            data-name="Rectangle 38"
            width="106"
            height="18"
            rx="9"
            transform="translate(0.622 0)"
            fill="#242e3a"
            opacity="0.07"
          />
        </g>
        <circle
          id="Ellipse_21-5"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 217)"
        />
        <g class="arrow" id="Arrow-5" data-name="Arrow">
          <path
            id="Path_497"
            data-name="Path 497"
            d="M6218.295,995.992l-47.336-16.336H6157"
            transform="translate(-5581.036 -754.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_227"
            data-name="Ellipse 227"
            cx="3"
            cy="3"
            r="3"
            transform="translate(635 239)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Head_Lamp-2"
          data-name="LFT Head Lamp"
          d="M375.1,329.094,351.114,360.86s-1.271.159-.953-1.112S346.226,336.7,375.1,329.094Z"
          transform="translate(288.761 -111.3)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Head_Lamp-3"
          data-name="LFT Head Lamp"
          transform="translate(481 229)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.lft_head_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-5"
          data-name="3.0"
          transform="translate(559 229)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.suv.lft_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-6"
          data-name="Rectangle 38"
          width="124"
          height="18"
          rx="9"
          transform="translate(452 186)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-6"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 186)"
        />
        <g class="arrow" id="Arrow-6" data-name="Arrow">
          <path
            id="Path_496"
            data-name="Path 496"
            d="M6235.674,992.407l-62.966-12.751-16.6-1.159"
            transform="translate(-5581.036 -783.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_228"
            data-name="Ellipse 228"
            cx="3"
            cy="3"
            r="3"
            transform="translate(653 207)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Indicator_lamp-2"
          data-name="LFT Indicator lamp"
          d="M418.8,290.8s6.746-7.675,12.15-4.691Z"
          transform="translate(235.086 -77.17)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Indicator_lamp-3"
          data-name="LFT Indicator lamp"
          transform="translate(467 198)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.lft_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-6"
          data-name="3.0"
          transform="translate(559 197)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['logo'] || ''"
        [attr.data-name]="'exterior.suv.logo' | translate"
      >
        <rect
          id="Rectangle_38-7"
          data-name="Rectangle 38"
          width="61"
          height="18"
          rx="9"
          transform="translate(515 155)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-7"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 155)"
        />
        <g class="arrow" id="Arrow-7" data-name="Arrow">
          <path
            id="Path_495"
            data-name="Path 495"
            d="M6279.428,1020.547l-98.837-40.891H6157"
            transform="translate(-5579.036 -815.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_199"
            data-name="Ellipse 199"
            cx="3"
            cy="3"
            r="3"
            transform="translate(700 203)"
            fill="#696969"
          />
        </g>
        <ellipse
          class="parts"
          id="Logo-2"
          data-name="Logo"
          cx="6.743"
          cy="1.656"
          rx="6.743"
          ry="1.656"
          transform="translate(700.978 203.341)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Logo-3"
          data-name="Logo"
          transform="translate(529 167)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.suv.logo' | translate }}</tspan>
        </text>
        <text
          id="_3.0-7"
          data-name="3.0"
          transform="translate(559 166)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_emblem'] || ''"
        [attr.data-name]="'exterior.suv.lft_rr_emblem' | translate"
      >
        <rect
          id="Rectangle_38-8"
          data-name="Rectangle 38"
          width="119"
          height="18"
          rx="9"
          transform="translate(456 498)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-8"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 498)"
        />
        <g class="arrow" id="Arrow-8" data-name="Arrow">
          <path
            id="Path_505"
            data-name="Path 505"
            d="M6221.287,988.813l-51.034-9.157H6157"
            transform="translate(-5581.036 -473.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_218"
            data-name="Ellipse 218"
            cx="3"
            cy="3"
            r="3"
            transform="translate(637 513)"
            fill="#696969"
          />
        </g>
        <circle
          class="parts"
          id="LFT_RR_Emblem-2"
          data-name="LFT RR Emblem"
          cx="2.087"
          cy="2.087"
          r="2.087"
          transform="translate(636.014 516.873)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_RR_Emblem-3"
          data-name="LFT RR Emblem"
          transform="translate(480 510)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.lft_rr_emblem' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-8"
          data-name="3.0"
          transform="translate(559 509)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_fender'] || ''"
        [attr.data-name]="'exterior.suv.lft_rr_fender' | translate"
      >
        <rect
          id="Rectangle_38-9"
          data-name="Rectangle 38"
          width="110"
          height="18"
          rx="9"
          transform="translate(466 467)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-9"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 467)"
        />
        <g class="arrow" id="Arrow-9" data-name="Arrow">
          <path
            id="Path_504"
            data-name="Path 504"
            d="M6221.549,1000.11l-51.817-20.454H6157"
            transform="translate(-5581.036 -502.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_219"
            data-name="Ellipse 219"
            cx="3"
            cy="3"
            r="3"
            transform="translate(637 495)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_RR_Fender-2"
          data-name="LFT RR Fender"
          d="M319.434,1523.835s-4.268,41.495,1.161,50.965c0,0,8.527,27.855,18.851,28.967,0,0-5.916.04-9.431-14.017a81.285,81.285,0,0,1-2.2-16.2l-2.144-35.618s-1.35-.059-1.668-.685-2.859-7.455-2.859-7.455l-.159-1.787Z"
          transform="translate(313.973 -1044.841)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_RR_Fender-3"
          data-name="LFT RR Fender"
          transform="translate(486 480)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.lft_rr_fender' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-9"
          data-name="3.0"
          transform="translate(559 479)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_door'] || ''"
        [attr.data-name]="'exterior.suv.lft_rr_door' | translate"
      >
        <rect
          id="Rectangle_38-10"
          data-name="Rectangle 38"
          width="103"
          height="18"
          rx="9"
          transform="translate(473 438)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-10"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 438)"
        />
        <g class="arrow" id="Arrow-10" data-name="Arrow">
          <path
            id="Path_517"
            data-name="Path 517"
            d="M6224.191,989.11l-53.938-9.454H6157"
            transform="translate(-5581.036 -533.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_220"
            data-name="Ellipse 220"
            cx="3"
            cy="3"
            r="3"
            transform="translate(640 453)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_RR_Door-2"
          data-name="LFT RR Door"
          d="M326.621,1180.554l.6,59.026s-1.033,2.839-1.469,15.982l1.549,4.169.159,1.787,2.541,6.83s.675,1.549,1.986,1.31a40.211,40.211,0,0,0,5.718-2.561l11.555-27.855-.655-49.753s-.037.37-1.009.137c0,0-2.942-.454-10.963-4.346l-7.227-2.025Z"
          transform="translate(307.794 -776.61)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_RR_Door-3"
          data-name="LFT RR Door"
          transform="translate(495 450)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.lft_rr_door' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-10"
          data-name="3.0"
          transform="translate(559 450)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rv_mirror'] || ''"
        [attr.data-name]="'exterior.suv.rht_r_v_mirror' | translate"
      >
        <rect
          id="Rectangle_38-11"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(477 340)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-11"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 340)"
        />
        <g class="arrow" id="Arrow-11" data-name="Arrow">
          <path
            id="Path_501"
            data-name="Path 501"
            d="M6207.951,975.15l-39.179,8.244H6157"
            transform="translate(-5581.036 -634.848)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_223"
            data-name="Ellipse 223"
            cx="3"
            cy="3"
            r="3"
            transform="translate(624 337)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="LFT_R.V_Mirror-2" data-name="LFT R.V Mirror">
          <path
            id="Path_970"
            data-name="Path 970"
            d="M358.253,838.372l-.238,7.386H356.03v-4.606s-.079-1.271-.715-1.191C355.315,839.96,355.752,838.848,358.253,838.372Z"
            transform="translate(284.69 -509.237)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_971"
            data-name="Path 971"
            d="M303.536,855.447l.2-8.775s.4-1.509-1.549-1.191c0,0-9.689,3.216-12.587,8.895s.318,7.624.318,7.624l11.674-4.606S303.52,856.161,303.536,855.447Z"
            transform="translate(336.985 -514.757)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="LFT_R.V_Mirror-3"
          data-name="LFT R.V Mirror"
          transform="translate(486 353)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.rht_r_v_mirror' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-11"
          data-name="3.0"
          transform="translate(559 351)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_door'] || ''"
        [attr.data-name]="'exterior.suv.lft_door' | translate"
      >
        <rect
          id="Rectangle_38-12"
          data-name="Rectangle 38"
          width="79"
          height="18"
          rx="9"
          transform="translate(497 370)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-12"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 370)"
        />
        <g class="arrow" id="Arrow-12" data-name="Arrow">
          <path
            id="Path_502"
            data-name="Path 502"
            d="M6218.14,975.531l-46.427,4.125H6157"
            transform="translate(-5581.036 -601.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_222"
            data-name="Ellipse 222"
            cx="3"
            cy="3"
            r="3"
            transform="translate(635 371)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Door-2"
          data-name="LFT Door"
          d="M329.24,785.519s7.028.655,7.624,3.574S348.9,829.535,348.9,842.579l2.323,38.239s.417,1.588-11.972-4.209c0,0-6.711-1.628-7.227-2.025l-2.78-2.7Z"
          transform="translate(305.064 -467.939)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-12"
          data-name="3.0"
          transform="translate(559 382)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_Door-3"
          data-name="LFT Door"
          transform="translate(510 382)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.suv.lft_door' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_frt_fender'] || ''"
        [attr.data-name]="'exterior.suv.lft_frt_fender' | translate"
      >
        <rect
          id="Rectangle_38-13"
          data-name="Rectangle 38"
          width="104"
          height="18"
          rx="9"
          transform="translate(470 309)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-13"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(556 309)"
        />
        <g class="arrow" id="Arrow-13" data-name="Arrow">
          <path
            id="Path_500"
            data-name="Path 500"
            d="M6213.22,976.464l-43.29,3.192H6157"
            transform="translate(-5581.036 -662.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_224"
            data-name="Ellipse 224"
            cx="3"
            cy="3"
            r="3"
            transform="translate(630 311)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_FRT_Fender-2"
          data-name="LFT FRT Fender"
          d="M325.985,459.233l-6.175,8.14-.774,39.381a27.675,27.675,0,0,0,2.144,9.817l.119,11.793s6.671.715,7.624,3.574l-.655-15.248,1.638-60.276-2.968,3.931S325.608,460.414,325.985,459.233Z"
          transform="translate(313.038 -210.785)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_FRT_Fender-3"
          data-name="LFT FRT Fender"
          transform="translate(481 322)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.lft_frt_fender' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-13"
          data-name="3.0"
          transform="translate(557 321)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['glasses'] || ''"
        [attr.data-name]="'exterior.suv.glasses' | translate"
      >
        <rect
          _ngcontent-bej-c129=""
          id="Rectangle_38-14"
          data-name="Rectangle 38"
          width="120"
          height="18"
          rx="9"
          transform="translate(460 278)"
          fill="#242e3a"
          opacity="0.07"
        ></rect>
        <circle
          id="Ellipse_21-14"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 278)"
        />
        <g class="arrow" id="Arrow-14" data-name="Arrow">
          <path
            id="Path_499"
            data-name="Path 499"
            d="M6276.377,1028.112l-95.831-48.457H6157"
            transform="translate(-5581.036 -693.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_225"
            data-name="Ellipse 225"
            cx="3"
            cy="3"
            r="3"
            transform="translate(692 332)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Glasses-2"
          data-name="Glasses"
          d="M416.127,750.767s49.138-19.477,105.96,0c0,0,4.467.536,0,22.336l-4.824,19.834s-.179,1.251-2.144.893-31.687-3.4-31.687-3.4-1.668.119-1.827-2.184-.913-6.512-.913-6.512-1.946-2.065-3.852-1.429c0,0,.477-3.1-7.147-2.78h-5.877a3.075,3.075,0,0,0-2.462,2.621s-3.832.318-3.941,2.7l-.983,6.433s1.509.874-1.827,1.032-31.766,4.289-31.766,4.289a2.567,2.567,0,0,1-2.144-1.827C420.376,791.189,410.29,754.579,416.127,750.767Z"
          transform="translate(238.591 -434.021)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-14"
          data-name="3.0"
          transform="translate(559 291)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Glasses-3"
          data-name="Glasses"
          transform="translate(475 291)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.suv.glasses' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['trunk_cargo'] || ''"
        [attr.data-name]="'exterior.suv.trunk_cargo' | translate"
      >
        <rect
          id="Rectangle_38-15"
          data-name="Rectangle 38"
          width="126"
          height="18"
          rx="9"
          transform="translate(644 635)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-15"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(752 635)"
        />
        <g class="arrow" id="Arrow-15" data-name="Arrow">
          <path
            id="Path_494"
            data-name="Path 494"
            d="M0,0,37.413,16.4h47"
            transform="translate(720.406 551.242) rotate(90)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_214"
            data-name="Ellipse 214"
            cx="3"
            cy="3"
            r="3"
            transform="translate(717 548)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="trunk_cargo-2"
          data-name="Trunk/Cargo"
          d="M472.328,1803.04s-5.956,11.793-1.906,15.129c0,0,9.45,4.646,28.828,4.884l4.209-1.191,16.757.079,4.368,1.112s19.219-.318,27.478-4.527c0,0,2.281-1.35,2.57-2.621s-.9-12.526-3.639-13.013c0,0-12.312,7.534-39.175,5.866,0,0-26.03.553-38.716-6.871Z"
          transform="translate(195.852 -1262.104)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-15"
          data-name="3.0"
          transform="translate(753 648)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="trunk_cargo-3"
          data-name="Trunk/Cargo"
          transform="translate(666 648)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.trunk_cargo' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['roof'] || ''"
        [attr.data-name]="'exterior.suv.roof' | translate"
      >
        <rect
          id="Rectangle_38-16"
          data-name="Rectangle 38"
          width="60"
          height="18"
          rx="9"
          transform="translate(844 492)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-16"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 492)"
        />
        <g class="arrow" id="Arrow-16" data-name="Arrow">
          <path
            id="Path_492"
            data-name="Path 492"
            d="M6157,979.656l123.876,7h30.44"
            transform="translate(-5467.315 -485.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_211"
            data-name="Ellipse 211"
            cx="3"
            cy="3"
            r="3"
            transform="translate(687 491)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Roof-2"
          data-name="Roof"
          d="M437.869,980.812s4.407,27.815,4.407,50.449l2.144,105.318s26.08,3.322,43.178,3.322c0,0,31.6.186,39.732-3.322a4.856,4.856,0,0,1,3.1,0l3.1-103.889,3.574-52.771s-28.732-5.98-49.5-5.98C487.6,973.939,450.317,974.141,437.869,980.812Z"
          transform="translate(220.185 -615.166)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-16"
          data-name="3.0"
          transform="translate(845 504)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Roof-3"
          data-name="Roof"
          transform="translate(866 504)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.suv.roof' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['others'] || ''"
        [attr.data-name]="'exterior.suv.other_1' | translate"
      >
        <rect
          id="Rectangle_38-17"
          data-name="Rectangle 38"
          width="81"
          height="18"
          rx="9"
          transform="translate(495 635)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-17"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(558 635)"
        />
        <text
          id="_3.0-17"
          data-name="3.0"
          transform="translate(559 647)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Other_1-2"
          data-name="Other 1"
          transform="translate(518 647)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.suv.other_1' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['tires'] || ''"
        [attr.data-name]="'exterior.suv.tyres' | translate"
      >
        <rect
          id="Rectangle_38-18"
          data-name="Rectangle 38"
          width="83"
          height="18"
          rx="9"
          transform="translate(844 635)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-18"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 635)"
        />
        <text
          id="_3.0-18"
          data-name="3.0"
          transform="translate(847 646)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Tyres-2"
          data-name="Tyres"
          transform="translate(866 647)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.suv.tyres' | translate }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_emblem'] || ''"
        [attr.data-name]="'exterior.suv.rht_rr_emblem' | translate"
      >
        <rect
          id="Rectangle_38-19"
          data-name="Rectangle 38"
          width="119"
          height="18"
          rx="9"
          transform="translate(844 542)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-19"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 542)"
        />
        <g class="arrow" id="Arrow-17" data-name="Arrow">
          <path
            id="Path_493"
            data-name="Path 493"
            d="M6229.984,960.915l38.543,29.2h27.406"
            transform="translate(-5451.935 -436.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_213"
            data-name="Ellipse 213"
            cx="3"
            cy="3"
            r="3"
            transform="translate(774 520)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_RR_Emblem-2"
          data-name="RHT RR Emblem"
          d="M971.328,1640.5l-.3,8.517a1.068,1.068,0,0,0,1.519.864c1.311-.477,1.311-4.639,1.311-4.639l.566-11.055a8.191,8.191,0,0,0-.625-2.68c-.447-.6-1.191-.775-1.549,0S971.328,1640.5,971.328,1640.5Z"
          transform="translate(-196.415 -1128.566)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_RR_Emblem-3"
          data-name="RHT RR Emblem"
          transform="translate(866 554)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.rht_rr_emblem' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-19"
          data-name="3.0"
          transform="translate(845 554)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_fender'] || ''"
        [attr.data-name]="'exterior.suv.rht_rr_fender' | translate"
      >
        <rect
          id="Rectangle_38-20"
          data-name="Rectangle 38"
          width="111"
          height="18"
          rx="9"
          transform="translate(844 463)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-20"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 463)"
        />
        <g class="arrow" id="Arrow-18" data-name="Arrow">
          <path
            id="Path_491"
            data-name="Path 491"
            d="M6174.433,1001.047l47.335-21.391h15.916"
            transform="translate(-5393.686 -507.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_210"
            data-name="Ellipse 210"
            cx="3"
            cy="3"
            r="3"
            transform="translate(778 491)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_RR_Fender-2"
          data-name="RHT RR Fender"
          d="M932.1,1523.644s4.268,41.495-1.162,50.965c0,0-8.527,27.855-18.851,28.967,0,0,5.917.04,9.431-14.017a81.275,81.275,0,0,0,2.2-16.2l2.144-35.618s1.35-.059,1.668-.685,2.859-7.455,2.859-7.455l.159-1.787Z"
          transform="translate(-150.362 -1044.692)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_RR_Fender-3"
          data-name="RHT RR Fender"
          transform="translate(866 475)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.rht_rr_fender' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-20"
          data-name="3.0"
          transform="translate(845 474)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_door'] || ''"
        [attr.data-name]="'exterior.suv.rht_rr_door' | translate"
      >
        <rect
          id="Rectangle_38-21"
          data-name="Rectangle 38"
          width="107"
          height="18"
          rx="9"
          transform="translate(844 435)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 435)"
        />
        <g class="arrow" id="Arrow-19" data-name="Arrow">
          <path
            id="Path_490"
            data-name="Path 490"
            d="M6157,979.656l62.374,6.468H6234.7"
            transform="translate(-5390.7 -542.124)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_209"
            data-name="Ellipse 209"
            cx="3"
            cy="3"
            r="3"
            transform="translate(764 434)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_RR_Door-2"
          data-name="RHT RR Door"
          d="M918.743,1180.554l-.6,59.026s1.033,2.839,1.469,15.982l-1.549,4.169-.159,1.787-2.541,6.83s-.675,1.549-1.986,1.31a40.2,40.2,0,0,1-5.718-2.561l-11.555-27.855.655-49.753s.036.37,1.008.137c0,0,2.942-.454,10.963-4.346l7.227-2.025Z"
          transform="translate(-137.873 -776.61)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_RR_Door-3"
          data-name="RHT RR Door"
          transform="translate(866 448)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.rht_rr_door' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-21"
          data-name="3.0"
          transform="translate(845 447)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rv_mirror'] || ''"
        [attr.data-name]="'exterior.suv.rht_r_v_mirror' | translate"
      >
        <rect
          id="Rectangle_38-22"
          data-name="Rectangle 38"
          width="107"
          height="18"
          rx="9"
          transform="translate(844 352)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-22"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 352)"
        />
        <g class="arrow" id="Arrow-20" data-name="Arrow">
          <path
            id="Path_488"
            data-name="Path 488"
            d="M6173.509,974.456l39.527,23.1h13.77"
            transform="translate(-5382.808 -633.006)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_206"
            data-name="Ellipse 206"
            cx="3"
            cy="3"
            r="3"
            transform="translate(787 338)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="RHT_R.V_Mirror-2" data-name="RHT R.V Mirror">
          <path
            id="Path_983"
            data-name="Path 983"
            d="M961.495,838.372l.238,7.386h1.986v-4.606s.079-1.271.715-1.191C964.433,839.96,964,838.848,961.495,838.372Z"
            transform="translate(-188.964 -509.237)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_984"
            data-name="Path 984"
            d="M971.745,855.447l-.2-8.775s-.4-1.509,1.549-1.191c0,0,9.689,3.216,12.587,8.895s-.318,7.624-.318,7.624l-11.674-4.606S971.761,856.161,971.745,855.447Z"
            transform="translate(-196.792 -514.757)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="RHT_R.V_Mirror-3"
          data-name="RHT R.V Mirror"
          transform="translate(866 364)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.rht_r_v_mirror' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-22"
          data-name="3.0"
          transform="translate(845 364)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_frt_door'] || ''"
        [attr.data-name]="'exterior.suv.rht_door' | translate"
      >
        <rect
          id="Rectangle_38-23"
          data-name="Rectangle 38"
          width="84"
          height="18"
          rx="9"
          transform="translate(844 381)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-23"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 381)"
        />
        <g class="arrow" id="Arrow-21" data-name="Arrow">
          <path
            id="Path_489"
            data-name="Path 489"
            d="M6157,979.656l62.374,13.485H6234.7"
            transform="translate(-5390.7 -600.641)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_207"
            data-name="Ellipse 207"
            cx="3"
            cy="3"
            r="3"
            transform="translate(763 376)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Door-2"
          data-name="RHT Door"
          d="M921.078,785.519s-7.028.655-7.624,3.574-12.032,40.442-12.032,53.486L899.1,880.818s-.417,1.588,11.972-4.209c0,0,6.711-1.628,7.227-2.025l2.78-2.7Z"
          transform="translate(-140.209 -467.939)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Door-3"
          data-name="RHT Door"
          transform="translate(866 394)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.suv.rht_door' | translate }}</tspan>
        </text>
        <text
          id="_3.0-23"
          data-name="3.0"
          transform="translate(845 393)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_frt_fender'] || ''"
        [attr.data-name]="'exterior.suv.rht_frt_fender' | translate"
      >
        <rect
          id="Rectangle_38-24"
          data-name="Rectangle 38"
          width="119"
          height="18"
          rx="9"
          transform="translate(844 321)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-24"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 321)"
        />
        <g class="arrow" id="Arrow-22" data-name="Arrow">
          <path
            id="Path_487"
            data-name="Path 487"
            d="M6165.263,976.515l54.108,21.427H6234.7"
            transform="translate(-5390.7 -667.396)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_205"
            data-name="Ellipse 205"
            cx="3"
            cy="3"
            r="3"
            transform="translate(771 306)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_FRT_Fender-2"
          data-name="RHT FRT Fender"
          d="M964.19,459.233l6.175,8.14.774,39.381a27.674,27.674,0,0,1-2.144,9.817l-.119,11.793s-6.671.715-7.624,3.574l.655-15.248-1.638-60.276,2.968,3.931S964.567,460.414,964.19,459.233Z"
          transform="translate(-188.006 -210.785)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_FRT_Fender-3"
          data-name="RHT FRT Fender"
          transform="translate(866 333)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.rht_frt_fender' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-24"
          data-name="3.0"
          transform="translate(845 333)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['protective_frt'] || ''"
        [attr.data-name]="'exterior.suv.wiper_blades' | translate"
      >
        <rect
          id="Rectangle_38-25"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(844 287)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-25"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 287)"
        />
        <g class="arrow" id="Arrow-23" data-name="Arrow">
          <path
            id="Path_486"
            data-name="Path 486"
            d="M6167.226,990.87l79.514-11.214h22.052"
            transform="translate(-5424.793 -684.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_204"
            data-name="Ellipse 204"
            cx="3"
            cy="3"
            r="3"
            transform="translate(740 304)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="Wiper_Blades-2" data-name="Protective FRT">
          <path
            id="Path_955"
            data-name="Path 955"
            d="M454.354,711.692h4.56l-.774,2.322-9.421.335Z"
            transform="translate(211.708 -410.253)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_956"
            data-name="Path 956"
            d="M492.447,714.953s6.929.412,11.773.276l10.721-.276,1.509.7-21.76.953.079,1.112,49.714-1.38v-1.38l-23.825.616s0-.616-2.859-.616l-2.3-1.449-12.389.4-10.006-.952Z"
            transform="translate(177.539 -411.234)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_959"
            data-name="Path 959"
            d="M661.813,700.454s6.492.914,6.73.973,7.267-.32,7.267-.32l15.605,2.383,1.966,1.75-14.414-3.276-2.144.119,40.9,11.436v-1.429l-20.33-5.877-2.7-1.429-2.3-2.3-30.575-4.686Z"
            transform="translate(45.2 -399.393)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="Wiper_Blades-3"
          data-name="Protective FRT"
          transform="translate(866 300)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.wiper_blades' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-25"
          data-name="3.0"
          transform="translate(845 299)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_head_lamp'] || ''"
        [attr.data-name]="'exterior.suv.rht_head_lamp' | translate"
      >
        <rect
          id="Rectangle_38-26"
          data-name="Rectangle 38"
          width="111"
          height="18"
          rx="9"
          transform="translate(844 252)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-26"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 252)"
        />
        <g class="arrow" id="Arrow-24" data-name="Arrow">
          <path
            id="Path_485"
            data-name="Path 485"
            d="M6157,979.656l54.585,19.546H6225"
            transform="translate(-5380.997 -738.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_203"
            data-name="Ellipse 203"
            cx="3"
            cy="3"
            r="3"
            transform="translate(773 238)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Head_lamp-2"
          data-name="RHT Head lamp"
          d="M864.143,329.094l23.983,31.766s1.271.159.953-1.112S893.015,336.7,864.143,329.094Z"
          transform="translate(-112.896 -111.3)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Head_lamp-3"
          data-name="RHT Head lamp"
          transform="translate(866 265)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.rht_head_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-26"
          data-name="3.0"
          transform="translate(845 264)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.suv.rht_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-27"
          data-name="Rectangle 38"
          width="126"
          height="18"
          rx="9"
          transform="translate(844 218)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-27"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 218)"
        />
        <g class="arrow" id="Arrow-25" data-name="Arrow">
          <path
            id="Path_484"
            data-name="Path 484"
            d="M6161.761,964.669l65.628,14.987h17.3"
            transform="translate(-5400.688 -753.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_202"
            data-name="Ellipse 202"
            cx="3"
            cy="3"
            r="3"
            transform="translate(757 207)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Indicator_lamp-2"
          data-name="RHT Indicator lamp"
          d="M856.515,288.063s3.832-3.335,11.634,3.991Z"
          transform="translate(-106.936 -78.647)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Indicator_lamp-3"
          data-name="RHT Indicator lamp"
          transform="translate(866 230)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.rht_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-27"
          data-name="3.0"
          transform="translate(845 230)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_grill'] || ''"
        [attr.data-name]="'exterior.suv.frt_grill' | translate"
      >
        <rect
          id="Rectangle_38-28"
          data-name="Rectangle 38"
          width="77"
          height="18"
          rx="9"
          transform="translate(844 155)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-28"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 155)"
        />
        <g class="arrow" id="Arrow-26" data-name="Arrow">
          <path
            id="Path_482"
            data-name="Path 482"
            d="M6162.824,1020.258l96.922-40.6H6285"
            transform="translate(-5440.997 -815.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_200"
            data-name="Ellipse 200"
            cx="3"
            cy="3"
            r="3"
            transform="translate(718 202)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="FRT_Grill-2"
          data-name="FRT Grill"
          d="M524.048,267.827H522.46l-36.611,7.306s-1.906-.159-1.032-1.509,14.374-9.689,39.231-10.642c0,0,31.329,1.549,38.953,10.721l-36.888-5.877Z"
          transform="translate(183.68 -59.642)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="FRT_Grill-3"
          data-name="FRT Grill"
          transform="translate(866 168)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.suv.frt_grill' | translate }}</tspan>
        </text>
        <text
          id="_3.0-28"
          data-name="3.0"
          transform="translate(845 167)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_bumper'] || ''"
        [attr.data-name]="'exterior.suv.frt_bumper' | translate"
      >
        <rect
          id="Rectangle_38-29"
          data-name="Rectangle 38"
          width="106"
          height="18"
          rx="9"
          transform="translate(844 184)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-29"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(844 184)"
        />
        <g class="arrow" id="Arrow-27" data-name="Arrow">
          <path
            id="Path_483"
            data-name="Path 483"
            d="M6167.808,993.84l78.932-14.184h22.053"
            transform="translate(-5424.793 -788.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_201"
            data-name="Ellipse 201"
            cx="3"
            cy="3"
            r="3"
            transform="translate(739 203)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="FRT_Bumper-2"
          data-name="FRT Bumper"
          d="M557.92,264.517s-5.36-1.083-5.936-.482c0,0-34.724-12.752-71.772,0h-5.837s14.533-6.864,41.772-6.864S555.577,263.564,557.92,264.517Z"
          transform="translate(191.66 -55.101)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="FRT_Bumper-3"
          data-name="FRT Bumper"
          transform="translate(866 196)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.suv.frt_bumper' | translate }}</tspan>
        </text>
        <text
          id="_3.0-29"
          data-name="3.0"
          transform="translate(845 196)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rocker_panel'] || ''"
        [attr.data-name]="'exterior.suv.rht_rocker_panel' | translate"
      >
        <rect
          id="Rectangle_38-30"
          data-name="Rectangle 38"
          width="123"
          height="18"
          rx="9"
          transform="translate(844 408)"
          fill="#242e3a"
          opacity="0.066"
        />
        <g
          id="Ellipse_21-30"
          data-name="Ellipse 21"
          transform="translate(844 408)"
          stroke-width="1"
        >
          <circle cx="9" cy="9" r="11" stroke="none" />
          <circle cx="9" cy="9" r="8.5" fill="none" />
        </g>
        <g class="arrow" id="Arrow-28" data-name="Arrow">
          <path
            id="Path_515"
            data-name="Path 515"
            d="M6157,979.656l58.66,3.222h14.415"
            transform="translate(-5386.071 -563.878)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_208"
            data-name="Ellipse 208"
            cx="3"
            cy="3"
            r="3"
            transform="translate(768 413)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Rocker_Panel-2"
          data-name="RHT Rocker Panel"
          d="M980.477,785.519l-3.172.633-2.189,174.836a1.784,1.784,0,0,0,1.985-1.31l2.541-6.83.159-1.787,1.549-4.169s-.517-14.672-1.469-15.982l.6-59.026Z"
          transform="translate(-199.607 -467.939)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-30"
          data-name="3.0"
          transform="translate(845 420)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_Rocker_Panel-3"
          data-name="RHT Rocker Panel"
          transform="translate(866 420)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.rht_rocker_panel' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rocker_panel'] || ''"
        [attr.data-name]="'exterior.suv.lft_rocker_panel' | translate"
      >
        <g class="arrow" id="Arrow-29" data-name="Arrow">
          <path
            id="Path_516"
            data-name="Path 516"
            d="M6226.858,978.052l-55.445,4.825H6157"
            transform="translate(-5592.071 -563.878)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_221"
            data-name="Ellipse 221"
            cx="3"
            cy="3"
            r="3"
            transform="translate(632 411)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Rocker_Panel-2"
          data-name="LFT Rocker Panel"
          d="M326.044,785.519l3.172.633L331.4,960.987a1.784,1.784,0,0,1-1.985-1.31l-2.541-6.83-.159-1.787-1.549-4.169s.516-14.672,1.469-15.982l-.6-59.026Z"
          transform="translate(308.245 -467.939)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_38-31"
          data-name="Rectangle 38"
          width="123"
          height="18"
          rx="9"
          transform="translate(451 408)"
          fill="#242e3a"
          opacity="0.066"
        />
        <g
          id="Ellipse_21-31"
          data-name="Ellipse 21"
          transform="translate(556 408)"
          stroke-width="1"
        >
          <circle cx="9" cy="9" r="11" stroke="none" />
          <circle cx="9" cy="9" r="8.5" fill="none" />
        </g>
        <text
          id="_3.0-31"
          data-name="3.0"
          transform="translate(557 421)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="LFT_Rocker_Panel-3"
          data-name="LFT Rocker Panel"
          transform="translate(473 420)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.suv.lft_rocker_panel' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['protectives_rr'] || ''"
        [attr.data-name]="'exterior.suv.rr_wiper' | translate"
      >
        <g class="arrow" id="Arrow-30" data-name="Arrow">
          <path
            id="Path_508"
            data-name="Path 508"
            d="M6157,1014.823l86.7,19h35.385"
            transform="translate(-5429.734 -450.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_212"
            data-name="Ellipse 212"
            cx="3"
            cy="3"
            r="3"
            transform="translate(726 561)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="RR_Wiper-2" data-name="Protective Rear">
          <path
            id="Path_1009"
            data-name="Path 1009"
            d="M659.2,1905.482l-.477-2.224,5.4-.2v2.422Z"
            transform="translate(47.613 -1341.158)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1010"
            data-name="Path 1010"
            d="M709.137,1893.252s-10.364,3.99-14.533,3.99l-11.178.576V1895.4l13.918-.647Z"
            transform="translate(28.313 -1333.495)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <circle
            id="Ellipse_239"
            data-name="Ellipse 239"
            cx="1.31"
            cy="1.31"
            r="1.31"
            transform="translate(706.417 559.944)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <rect
          id="Rectangle_38-32"
          data-name="Rectangle 38"
          width="100"
          height="18"
          rx="9"
          transform="translate(845 574)"
          fill="#242e3a"
          opacity="0.07"
        />
        <ellipse
          id="Ellipse_21-32"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          rx="11"
          ry="11"
          transform="translate(845 574)"
        />
        <text
          id="RR_Wiper-3"
          data-name="Protective Rear"
          transform="translate(866 586)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'exterior.suv.rr_wiper' | translate }}</tspan>
        </text>
        <text
          id="_3.0-32"
          data-name="3.0"
          transform="translate(845 587)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
    </g>
  </svg>
</div>

<div
  class="container mt-4"
  style="display: flex; align-items: center; justify-content: center; gap: 1rem"
>
  <div class="alert alert-success d-inline-block py-1 px-3">
    <strong>&quot;*&quot;</strong> : {{ 'exterior.qc_passed' | translate }}
  </div>
  <div class="alert alert-danger d-inline-block py-1 px-3">
    <strong>&quot;-&quot;</strong> : {{ 'exterior.qc_failed' | translate }}
  </div>
</div>

<!-- Modal -->
<ng-template #condition>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>

    <div>
      <app-rating-activity
        [vehicleId]="vehicleId"
        [parentPartId]="partId"
        (logDetails)="receiveData($event)"
      ></app-rating-activity>
    </div>

    <button type="button" class="close" (click)="modalRef.hide()">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>
  <form
    class="condition__form credential"
    [formGroup]="conditionForm"
    (submit)="saveConditionState()"
  >
    <div class="modal-body conditionModal__body">
      <div class="vam_show_car_form_container">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.condition' | translate
              }}</label>
              <ng-container *ngIf="lang == 'en'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="form-control credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  style="border: none"
                >
                </ng-select>
              </ng-container>
              <ng-container *ngIf="lang == 'ar'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="form-control credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name_arabic"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  style="border: none"
                >
                </ng-select>
              </ng-container>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.severity' | translate
              }}</label>
              <select
                class="form-control credential__select-lg"
                formControlName="vpcs_severity"
                [class.is-invalid]="formData.vpcs_severity.invalid && this.submitted"
                [attr.disabled]="role === 'estimator' || role === 'purchasemanager' ? '' : null"
              >
                <option value="" disabled="true" selected="true">Select Severity</option>
                <option [value]="1">1 (Part change)</option>
                <option [value]="2">2 (Major Repair)</option>
                <option [value]="3">3 (Moderate Repair)</option>
                <option [value]="4">4 (Minor Repair)</option>
                <option [value]="5">5 (Good part)</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="container mt-4 p-0">
            <form
              *ngIf="['qc', 'admin'].includes(role) && qcOptions.length && qcConditions.length"
              [formGroup]="qcForm"
              class="border p-3"
            >
              <div class="mb-4">
                <button
                  type="button"
                  class="btn qc-toggle-btn"
                  [class.qc-toggle-active]="toggle"
                  (click)="this.toggle = !this.toggle"
                  aria-pressed="false"
                  autocomplete="off"
                >
                  <span class="qc-toggle-label-on">Pass</span>
                  <span class="qc-toggle-label-off">Fail</span>
                  <div class="qc-toggle-handle"></div>
                </button>
              </div>
              <div
                class="d-flex form-group"
                *ngFor="let qcCondition of qcConditions; let i = index"
                [ngClass]="{ 'mt-3': i > 0 }"
              >
                <label [for]="qcCondition?.['condition_id']" class="col-form-label">
                  {{ qcCondition?.['parts_condition_name_' + lang] }}:
                </label>

                <div class="ml-3 flex-grow-1">
                  <select
                    class="form-control"
                    [id]="qcCondition?.['condition_id']"
                    [formControlName]="qcCondition?.['condition_id']"
                    [class.is-invalid]="hasError(qcCondition?.['condition_id'])"
                  >
                    <option value="">-- Please select --</option>
                    <option
                      *ngFor="let qcOption of qcOptions"
                      [value]="qcOption?.['review_status_id']"
                    >
                      {{ qcOption?.['name_' + lang] }}
                    </option>
                  </select>
                  <div *ngIf="hasError(qcCondition?.['condition_id'])" class="invalid-feedback">
                    {{ getErrorMessage(qcCondition?.['condition_id']) }}
                  </div>
                </div>
              </div>
              <div class="mt-3 p-2 bg-light rounded" *ngIf="qcForm">
                <small>
                  <strong>Work status:</strong>
                  <span [ngClass]="toggle ? 'text-success' : 'text-danger'">
                    {{ toggle ? 'Passed' : 'Failed' }}
                  </span>
                </small>
              </div>
            </form>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.description' | translate
              }}</label>
              <!-- <label class="modal_car_input_label">Description</label> -->
              <textarea
                class="form-control credential__textarea"
                formControlName="vpcs_s_dec"
                [class.is-invalid]="formData.vpcs_s_dec.invalid && this.submitted"
                [readonly]="role === 'evaluator' || role === 'purchasemanager'"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.labour_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_lb_cost"
                formControlName="vpcs_lb_cost"
                [class.is-invalid]="formData.vpcs_lb_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #labourCost
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.parts_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_prt_cost"
                formControlName="vpcs_prt_cost"
                [class.is-invalid]="formData.vpcs_prt_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #partsCost
              />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.cost_of_repair' | translate
              }}</label>
              <input
                type="text"
                name="vpcs_rp_cost"
                formControlName="vpcs_rp_cost"
                class="form-control credential__input-lg"
                [class.is-invalid]="formData.vpcs_rp_cost.invalid && this.submitted"
                [value]="+labourCost.value + +partsCost.value || ''"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.before' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image1"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image1"
                  formControlName="vpcs_old_image1"
                  class="form-conrol d-none"
                  id="vpcs_old_image1"
                  (change)="getFile($event, 'old', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld1'] || imageOld['beforeImg1']"
                />
                <img
                  [src]="imageOld['beforeImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg1'] && !filesOld['fileOld1']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld1'] && !imageOld['beforeImg1']">
                  {{ filesOld['fileOld1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld1'] || imageOld['beforeImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg1']"
                  (click)="openViewer(imageOld['beforeImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="
                    !vehicleStatus &&
                    ((editableRole.includes(role) && role !== 'estimator') ||
                      ['qc', 'evaluator'].includes(role))
                  "
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld1'] || imageOld['beforeImg1'], 'old', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image2"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image2"
                  formControlName="vpcs_old_image2"
                  class="form-conrol d-none"
                  id="vpcs_old_image2"
                  (change)="getFile($event, 'old', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld2'] || imageOld['beforeImg2']"
                />
                <img
                  [src]="imageOld['beforeImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg2'] && !filesOld['fileOld2']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld2'] && !imageOld['beforeImg2']">
                  {{ filesOld['fileOld2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld2'] || imageOld['beforeImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg2']"
                  (click)="openViewer(imageOld['beforeImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="
                    !vehicleStatus &&
                    ((editableRole.includes(role) && role !== 'estimator') ||
                      ['qc', 'evaluator'].includes(role))
                  "
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld2'] || imageOld['beforeImg2'], 'old', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.after' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image1"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image1"
                  formControlName="vpcs_new_image1"
                  class="form-conrol d-none"
                  id="vpcs_new_image1"
                  (change)="getFile($event, 'new', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew1'] || imageNew['afterImg1']"
                />
                <img
                  [src]="imageNew['afterImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg1'] && !filesNew['fileNew1']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew1'] && !imageNew['afterImg1']">
                  {{ filesNew['fileNew1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew1'] || imageNew['afterImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg1']"
                  (click)="openViewer(imageNew['afterImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew1'] || imageNew['afterImg1'], 'new', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image2"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image2"
                  formControlName="vpcs_new_image2"
                  class="form-conrol d-none"
                  id="vpcs_new_image2"
                  (change)="getFile($event, 'new', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew2'] || imageNew['afterImg2']"
                />
                <img
                  [src]="imageNew['afterImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg2'] && !filesNew['fileNew2']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew2'] && !imageNew['afterImg2']">
                  {{ filesNew['fileNew2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew2'] || imageNew['afterImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg2']"
                  (click)="openViewer(imageNew['afterImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew2'] || imageNew['afterImg2'], 'new', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <loader [position]="{ absolute: true }" [active]="partConditionLoaded"></loader>
    </div>

    <div class="modal-footer conditionModal__footer">
      <div class="conditionModal__footerInner">
        <div
          class="row w-100 mx-0"
          *ngIf="
            !vehicleStatus &&
            ((editableRole.includes(role) && role !== 'estimator') ||
              ['qc', 'evaluator'].includes(role))
          "
        >
          <div class="col-md-6 px-0 px-md-2 mb-3 mb-md-0">
            <button
              type="submit"
              class="btn btn-primary w-100"
              [disabled]="partConditionLoaded || conditionSubmitting || role === 'purchasemanager'"
            >
              {{ 'condition_modal.save' | translate }}
              <span
                class="spinner-grow spinner-grow-sm text-light ml-2"
                [hidden]="!conditionSubmitting"
              >
              </span>
            </button>
          </div>
          <div class="col-md-6 px-0 px-md-2">
            <button
              type="button"
              class="btn btn__secondary w-100"
              [disabled]="partConditionLoaded"
              (click)="modalRef.hide(); conditionForm.reset()"
            >
              {{ 'condition_modal.set_default' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>
